import "./assets/css/style.css";
import "./assets/css/transitions.css";
import "./assets/css/utils.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueClickAway from "vue3-click-away";
import VueGtag from "vue-gtag-next";
import JsonViewer from "vue3-json-viewer";
import Maska from "maska";
import { getGoogleAnalyticsCode } from "./utils/functions";
// import { VTooltip } from "v-tooltip";
//import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas);

const gaCode = getGoogleAnalyticsCode();


const env = "engage"

const domainMappings = [
  {
    oldDomain: "localhost",
    newDomain: `froedtertsouth.${env}.benefitscreening.com`,
    newPath: "/quick/",
  },
  {
    oldDomain: "froedtert.quick.benefitscreening.com",
    newDomain: `froedtertsouth.${env}.benefitscreening.com`,
    newPath: "/quick/",
  },
  {
    oldDomain: "riverside.quick.benefitscreening.com",
    newDomain: `riverside-outreach.${env}.benefitscreening.com`,
    newPath: "/quick/",
  },
  {
    oldDomain: "thrive.quick.benefitscreening.com",
    newDomain: `thrive.${env}.benefitscreening.com`,
    newPath: "/quick/",
  },
  {
    oldDomain: "livewell.quick.benefitscreening.com",
    newDomain: `livewell.${env}.benefitscreening.com`,
    newPath: "/quick/",
  },
  {
    oldDomain: "ascensionillinois.quick.benefitscreening.com",
    newDomain: `ascensionillinois.${env}.benefitscreening.com`,
    newPath: "/quick/",
  },
  
  // add more mappings here
];

// Optional: map old query params to new ones
export const queryParamMapping = {
  utm_source: "src",
  utm_medium: "medium",
  utm_campaign: "campaign",
  lang: "lang",
};



export function getRedirectUrl(currentUrl) {
  try {
    const parsed = new URL(currentUrl);
      console.log("currentURL: " + currentUrl)

    const mapping = domainMappings.find(m => parsed.host.includes(m.oldDomain));
    if (!mapping) return null;

    const newQuery = {};
    parsed.searchParams.forEach((value, key) => {
      console.log("Key: " + key + " Value: " + value)
      newQuery[queryParamMapping[key] || key] = value;
    });

    if (env == "sandbox"){
      newQuery["env"] = "SANDBOX"
    }
    // Build full URL with protocol to avoid relative path issues
    const newUrl = `${parsed.protocol}//${mapping.newDomain}${mapping.newPath}?${new URLSearchParams(newQuery).toString()}`;
    return newUrl;
  } catch (err) {
    console.error("Invalid URL", currentUrl, err);
    return null;
  }
}


// export function getRedirectUrl(currentUrl) {
//   try {
//     const parsed = new URL(currentUrl);
//     console.log("CurrentURL: " + currentUrl);

//     const mapping = domainMappings.find(m => parsed.host.includes(m.oldDomain));
//     if (!mapping) return null;

//     const newQuery = {};
//     parsed.searchParams.forEach((value, key) => {
//       newQuery[queryParamMapping[key] || key] = value;
//     });

//     const newUrl = new URL(parsed);
//     newUrl.hostname = mapping.newDomain;
//     newUrl.pathname = mapping.newPath;
//     newUrl.search = new URLSearchParams(newQuery).toString();

//     console.log("NewURL: " + newUrl.toString());

//     return newUrl.toString();
//   } catch (err) {
//     console.error("Invalid URL", currentUrl, err);
//     return null;
//   }
// }

  //const testUrl = "https://froedtert.quick.benefitscreening.com?utm_source=Direct&utm_medium=SocialMedia&utm_campaign=OEP&lang=es";

//const redirectUrl = getRedirectUrl(testUrl);
const redirectUrl = getRedirectUrl(window.location.href);


if (redirectUrl && redirectUrl !== window.location.href) {  
    window.location.replace(redirectUrl);
}


if (redirectUrl && redirectUrl !== window.location.href) {
  // full redirect to new domain/path
  window.location.replace(redirectUrl);
} 
else {
    const app = createApp(App);
    app
      .use(JsonViewer)
      .use(router)
      .use(VueClickAway)
      .component("fa", FontAwesomeIcon)
      .use(VueGtag, {
        property: { id: gaCode },
      })
      .use(Maska)
      .mount("#app");
}


